import loadApp from '~/services/bootstrap';
import App from './app.vue';

loadApp('#investment-app', App);
